import { NS_CONFIGURATION, PROJECT, EDITOR, STATUS, CURRENT } from 'redux/constants';
import { action, createType, ASYNC, SYNC } from 'redux-create-type';


export const {
  INIT,
  SET_NAME,
  SET_COLOR,
  SET_ORDER,
  SET_ITEM_COLOR,
  SET_COMPLETED_ON_SPRINT,
  SET_CALCULATE_SPENT_TIME,
  INVALIDATE_CHANGES,
  SET_REMOVED,
  RESET_CHANGES,
} = createType(NS_CONFIGURATION, PROJECT, EDITOR, STATUS, CURRENT)({
    INIT: ASYNC,
    SET_NAME: SYNC,
    SET_COLOR: SYNC,
    SET_ORDER: SYNC,
    INVALIDATE_CHANGES: SYNC,
    SET_ITEM_COLOR: SYNC,
    SET_COMPLETED_ON_SPRINT: SYNC,
    SET_CALCULATE_SPENT_TIME: SYNC,
    SET_REMOVED: SYNC,
    RESET_CHANGES: ASYNC,
  });


export const init = {
  begin: localId => action(INIT.BEGIN, { localId }),
  end: ({ selectedStatus }) => action(INIT.END, { selectedStatus }),
};
export const setName = name => action(SET_NAME, { name });
export const setColor = color => action(SET_COLOR, { color });
export const setOrder = order => action(SET_ORDER, { order });
export const setRemoved = value => action(SET_REMOVED, { value });
export const setItemColor = ({ itemType, color }) => action(SET_ITEM_COLOR, { itemType, color });
export const setCompletedOnSprint = ({ itemType, value }) => action(SET_COMPLETED_ON_SPRINT, { itemType, value });
export const setCalculateSpentTime = ({ itemType, value }) => action(SET_CALCULATE_SPENT_TIME, { itemType, value });
export const invalidateChanges = ({ changes }) => action(INVALIDATE_CHANGES, { changes });
export const resetChanges = {
  begin: () => action(RESET_CHANGES.BEGIN),
  end: ({
    value,
    }) => action(RESET_CHANGES.END, {
      value,
    }),
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/status/currentStatus/actions.js